import React, { Suspense, useContext, useEffect, useState } from "react";
import { Trans, useTranslation } from "react-i18next";
import { Modal, Notification, toaster } from "rsuite";
import UploadedProfilesDetails from "./UploadedProfilesDetails";
import CreateProfileUpload from "./CreateProfileUpload";
import CreateProfileForm from "./CreateProfileForm";
import CreateManualProfileMain from "./CreateManualProfileMain";
import { Button, Spinner } from "react-bootstrap";
import Loading from "../../Loder";
import useIsSsr from "../../customhooks/UseIsSSR";
import UserContext from "../../app/context/UserContext";
import { useSearchParams } from "react-router-dom";
import { useForm } from "react-hook-form";
import UploadProfileNewLayout from "./UploadProfileNewLayout";
import usePost from "../../customhooks/UsePost";
import { DateTime } from "luxon";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faForward,
  faForwardFast,
  faMagnifyingGlass,
  faSuitcase,
} from "@fortawesome/free-solid-svg-icons";
import { parsePhoneNumber } from "react-phone-number-input";
import countryNames from "react-phone-number-input/locale/en";
import ToasterNotification from "../../utilities/ToasterNotification";

const ApplyNowNewLayout = ({
  setOpenModal=()=>{},
  open,
  setOpen,
  campaignID="",
  page,
  setOpenDuplicate,
  setDuplicateProfiles,
  setCookie,
  setResumeID,
  setupdatadataMri,
  companyID,
  notduplicate,
  updateReferraldataLoading,
  setGuestCookie=()=>{},
  setOpenLinkProfile=()=>{},
  setPage,
  campaignName=""
}) => {
  const isSsr = useIsSsr();
  const { user, setUser } = useContext(UserContext);
  const { t } = useTranslation();
  const [showUploadedProfiles, setShowUploadedProfiles] = useState(false);
  const [uploadedProfiles, setUploadedProfiles] = useState([]);
  const [createManualProfile, setCreateManualProfile] = useState(false);
  const [searchParams] = useSearchParams();
  const [step, setStep] = useState(0);
  const [resumeId, setResumeId] = useState("");
  const [fromUpload, setFromUpload] = useState(false);
  const {
    register,
    control,
    getValues,
    setValue,
    watch,
    clearErrors,
    formState: { errors },
    setError,
    handleSubmit,
    reset,
  } = useForm();

  const fileOnChange = (files) => {
    setShowUploadedProfiles(true);
    setCreateManualProfile(false);
    setUploadedProfiles(...uploadedProfiles, files);
  };

  const handleLogin = () => {
    setPage("login");
    setOpenLinkProfile(false);
    setOpen(false);
    setOpenModal(true);
    setDuplicateProfiles([]);
    setOpenDuplicate(false);
  };

  function getBase64File(file) {
    if (file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result.split(";base64,")[1]);
        reader.onerror = (error) => reject(error);
      });
    }
  }

  const { post: setCookies } = usePost("/setcookie");

  // usePost
  const {
    post: uploadResumes,
    data: uploadResumesData,
    isLoading: uploadResumesLoading,
    error: uploadResumesError,
  } = usePost("/user/uploadResumes");

  const {
    post: createUserResumes,
    data: createUserResumesData,
    isLoading: createUserResumesLoading,
    error: createUserResumesError,
  } = usePost("/user/createUserResumes");

  const {
    post: uploadUserResumes,
    data: uploadUserResumesData,
    isLoading: uploadUserResumesLoading,
    error: uploadUserResumesError,
  } = usePost("/user/uploadUserResumes");
  console.log(page, "dfffffffffffffffffffffffff");
  const uploadProfiles = async () => {
    setCreateManualProfile(false);
    if (page == "userbasicprofile" || page == "referalresume") {
      if (getValues()?.UploadProfiles?.length <= 1) {
        for (let i in getValues()?.UploadProfiles) {
          let file = getValues()?.UploadProfiles[i];
          if (file?.blobFile.size <= 2e6) {
            let fileType = file?.name?.split(".").pop().toLowerCase();
            let acceptedFileTypes = [
              "doc",
              "docx",
              "pdf",
              // "rtf",
              "txt",
              // "odt",
              // "ott",
              // "htm",
              // "html",
              // // "ods",
              // "xls",
              // "xlsx",
              // "csv",
            ];
            if (acceptedFileTypes.includes(fileType)) {
              let base64Files = [];
              base64Files.push({
                originalname: file.name,
                size: file.blobFile.size,
                type: "docFile",
                path: "",
                base64File: await getBase64File(file.blobFile),
              });
              if (base64Files?.length > 0) {
                uploadUserResumes({
                  base64Files: base64Files,
                  from: page != "" ? page : "",
                  // campaignID:
                  //   campaignID != undefined && campaignID != "" ? campaignID : "",
                  jobSeekerID:
                    user?._id != undefined && user?._id != "" ? user?._id : "",
                  source:
                    searchParams.get("source") != null
                      ? searchParams.get("source")
                      : "",
                  referenceURL: isSsr
                    ? ""
                    : window.location.origin + window.location.pathname,
                  companyID:
                    page == "userbasicprofile" ? user?.companyID : companyID,
                })
                  .then((resp) => {
                    console.log("response", resp);

                    if (resp?.status) {
                      if (resp?.result?.status && resp.result.status === true) {
                        setResumeID(resp.result?.resumeID);
                        if (page == "userbasicprofile") {
                          if (
                            resp?.result?.resumeID &&
                            resp.result.resumeID != ""
                          ) {
                            setUser({
                              ...user,
                              resumeID: resp.result.resumeID,
                            });
                          }
                        }

                        // toaster.push(
                        //   <Notification
                        //     type={"success"}
                        //     header={t("success", { defaultValue: "Success" })}
                        //     closable
                        //   >
                        //     {t("resumeCreatedSuccessfully", {
                        //       defaultValue: "Resume created Successfully",
                        //     })}
                        //   </Notification>,
                        //   { placement: "topEnd" }
                        // );
                        ToasterNotification({
                          type: "success",
                          i18keyFormat: "resumeCreatedSuccessfully",
                          message: "Resume created Successfully",
                          options: { position: "top-right", autoClose: 5000 },
                        });
                        setOpen(false);
                      }
                    } else {
                      // toaster.push(
                      //   <Notification
                      //     type={"error"}
                      //     header={t("error", { defaultValue: "Error" })}
                      //     closable
                      //   >
                      //     {t("somethingWentWrongPleaseTryAgainLater", {
                      //       defaultValue:
                      //         "Something went wrong please try again later",
                      //     })}
                      //   </Notification>,
                      //   { placement: "topEnd" }
                      // );
                      ToasterNotification({
                        type: "error",
                        i18keyFormat: "somethingWentWrongPleaseTryAgainLater",
                        message: "Something went wrong please try again later",
                        options: { position: "top-right", autoClose: 5000 },
                      });
                    }
                  })
                  .catch((error) => {
                    // console.log("error", error)
                  });
              }
            } else {
              setShowUploadedProfiles(false);
              setUploadedProfiles([]);
              // toaster.push(
              //   <Notification
              //     type={"error"}
              //     header={t("error", { defaultValue: "Error" })}
              //     closable
              //   >
              //     {t("pleaseUploadTheAcceptedFileFormats", {
              //       defaultValue: "Please upload the accepted file formats",
              //     })}
              //   </Notification>,
              //   { placement: "topEnd" }
              // );
              ToasterNotification({
                type: "error",
                i18keyFormat: "pleaseUploadTheAcceptedFileFormats",
                message: "Please upload the accepted file formats",
                options: { position: "top-right", autoClose: 5000 },
              });
            }
          } else {
            setShowUploadedProfiles(false);
            setUploadedProfiles([]);
            // toaster.push(
            //   <Notification
            //     type={"error"}
            //     header={t("error", { defaultValue: "Error" })}
            //     closable
            //   >
            //     {t("pleaseUploadAFileLessThanMb", {
            //       defaultValue: "Please upload a file less than 2Mb",
            //     })}
            //   </Notification>,
            //   { placement: "topEnd" }
            // );
            ToasterNotification({
              type: "error",
              i18keyFormat: "pleaseUploadAFileLessThanMb",
              message: "Please upload a file less than 2Mb",
              options: { position: "top-right", autoClose: 5000 },
            });
          }
        }
      } else {
        // toaster.push(
        //   <Notification
        //     type={"error"}
        //     header={t("error", { defaultValue: "Error" })}
        //     closable
        //   >
        //     {t("uploadingFilesLimitIs", {
        //       defaultValue: "Uploading files limit is 1",
        //     })}
        //   </Notification>,
        //   { placement: "topEnd" }
        // );
        ToasterNotification({
          type: "error",
          i18keyFormat: "uploadingFilesLimitIs",
          message: "Uploading files limit is 1",
          options: { position: "top-right", autoClose: 5000 },
        });
      }
    } else {
      if (getValues()?.UploadProfiles?.length <= 1) {
        for (let i in getValues()?.UploadProfiles) {
          let file = getValues()?.UploadProfiles[i];
          if (file?.blobFile.size <= 2e6) {
            let fileType = file?.name?.split(".").pop().toLowerCase();
            let acceptedFileTypes = [
              "doc",
              "docx",
              "pdf",
              // "rtf",
              "txt",
              // "odt",
              // "ott",
              // "htm",
              // "html",
              // // "ods",
              // "xls",
              // "xlsx",
              // "csv",
            ];
            if (acceptedFileTypes.includes(fileType)) {
              let base64Files = [];
              base64Files.push({
                originalname: file.name,
                size: file.blobFile.size,
                type: "docFile",
                path: "",
                base64File: await getBase64File(file.blobFile),
              });
              if (base64Files?.length > 0) {
                uploadResumes({
                  base64Files: base64Files,
                  from: page != "" ? page : "",
                  campaignID:
                    campaignID != undefined && campaignID != ""
                      ? campaignID
                      : "",
                  jobSeekerID:
                    user?._id != undefined && user?._id != "" ? user?._id : "",
                  source:
                    searchParams.get("source") != null
                      ? searchParams.get("source")
                      : "",
                  referenceURL: isSsr
                    ? ""
                    : window.location.origin + window.location.pathname,
                })
                  .then((resp) => {
                    // console.log("response", resp)

                    if (resp?.status) {
                      if (resp?.result?.status && resp.result.status === true) {
                        if (page && page == "login") {
                          if (resp?.result?.details) {
                            setResumeId(resp?.result?.resumeID);
                            // toaster.push(
                            //   <Notification
                            //     type={"success"}
                            //     header={t("success", {
                            //       defaultValue: "Success",
                            //     })}
                            //     closable
                            //   >
                            //     {t("pleaseCheckYourProfile", {
                            //       defaultValue: "Please Check Your Profile",
                            //     })}
                            //   </Notification>,
                            //   { placement: "topEnd" }
                            // );
                            ToasterNotification({
                              type: "success",
                              i18keyFormat: "pleaseCheckYourProfile",
                              message: "Please Check Your Profile",
                              options: { position: "top-right", autoClose: 5000 },
                            });
                            // setShowUploadedProfiles(true);
                            setFromUpload(true);
                            setUploadedProfiles([]);
                            setCreateManualProfile(true);
                          } else if (resp?.result?.required) {
                            setResumeId(resp?.result?.resumeID);
                            // toaster.push(
                            //   <Notification
                            //     type={"success"}
                            //     header={t("success", {
                            //       defaultValue: "Success",
                            //     })}
                            //     closable
                            //   >
                            //     {t("pleaseCompleteYourProfile", {
                            //       defaultValue: "Please Complete Your Profile",
                            //     })}
                            //   </Notification>,
                            //   { placement: "topEnd" }
                            // );
                            ToasterNotification({
                              type: "success",
                              i18keyFormat: "pleaseCompleteYourProfile",
                              message: "Please Complete Your Profile",
                              options: { position: "top-right", autoClose: 5000 },
                            });
                            // setShowUploadedProfiles(true);
                            setFromUpload(true);
                            setUploadedProfiles([]);
                            setCreateManualProfile(true);
                          } else {
                            if (
                              resp?.result?.resumeID &&
                              resp.result.resumeID != ""
                            ) {
                              setUser({
                                ...user,
                                resumeID: resp.result.resumeID,
                              });
                            }

                            if (
                              resp?.result?.campaignID &&
                              resp.result.campaignID != ""
                            ) {
                              if (
                                !user.attachedCampaigns.includes(
                                  resp.result.campaignID
                                )
                              ) {
                                setUser({
                                  ...user,
                                  attachedCampaigns: [
                                    ...user.attachedCampaigns,
                                    resp.result.campaignID,
                                  ],
                                });
                              }
                            }
                            // toaster.push(
                            //   <Notification
                            //     type={"success"}
                            //     header={t("success", {
                            //       defaultValue: "Success",
                            //     })}
                            //     closable
                            //   >
                            //     {t("jobAppliedSuccessfully", {
                            //       defaultValue: "Job applied Successfully",
                            //     })}
                            //   </Notification>,
                            //   { placement: "topEnd" }
                            // );
                            ToasterNotification({
                              type: "success",
                              i18keyFormat: "jobAppliedSuccessfully",
                              message: "Job applied Successfully",
                              options: { position: "top-right", autoClose: 5000 },
                            });
                          }
                        } else {
                          if (page && page == "guest") {
                            // setting resumeID in cookies for guest user
                            if (resp?.result?.details) {
                              setResumeId(resp?.result?.resumeID);
                              // toaster.push(
                              //   <Notification
                              //     type={"success"}
                              //     header={t("success", {
                              //       defaultValue: "Success",
                              //     })}
                              //     closable
                              //   >
                              //     {t("pleaseCheckYourProfile", {
                              //       defaultValue: "Please Check Your Profile",
                              //     })}
                              //   </Notification>,
                              //   { placement: "topEnd" }
                              // );
                              ToasterNotification({
                                type: "success",
                                i18keyFormat: "pleaseCheckYourProfile",
                                message: "Please Check Your Profile",
                                options: { position: "top-right", autoClose: 5000 },
                              });
                              // setShowUploadedProfiles(true);
                              setFromUpload(true);
                              setUploadedProfiles([]);
                              setCreateManualProfile(true);
                            } else if (resp?.result?.required) {
                              setResumeId(resp?.result?.resumeID);
                              // toaster.push(
                              //   <Notification
                              //     type={"success"}
                              //     header={t("success", {
                              //       defaultValue: "Success",
                              //     })}
                              //     closable
                              //   >
                              //     {t("pleaseCompleteYourProfile", {
                              //       defaultValue:
                              //         "Please Complete Your Profile",
                              //     })}
                              //   </Notification>,
                              //   { placement: "topEnd" }
                              // );
                              ToasterNotification({
                                type: "success",
                                i18keyFormat: "pleaseCompleteYourProfile",
                                message: "Please Complete Your Profile",
                                options: { position: "top-right", autoClose: 5000 },
                              });
                              // setShowUploadedProfiles(true);
                              setFromUpload(true);
                              setUploadedProfiles([]);
                              setCreateManualProfile(true);
                            } else {
                              if (
                                resp?.result?.resumeID &&
                                resp.result.resumeID != ""
                              ) {
                                setCookies({
                                  cookieName: "Guest_User_ResumeID",
                                  cookieValue: resp?.result?.resumeID,
                                  expires: DateTime.now()
                                    .plus({ months: 3 })
                                    .toISO(),
                                })
                                  .then((res) => {
                                    // console.log("cookie res", res);

                                    if (res?.status) {
                                      setCookie(resp?.result?.resumeID);
                                      setupdatadataMri(true);
                                      setGuestCookie(resp?.result?.resumeID);
                                    }
                                  })
                                  .catch((error) => {
                                    console.log("Error in setCookie : ", error);
                                  });
                              }

                              // toaster.push(
                              //   <Notification
                              //     type={"success"}
                              //     header={t("success", {
                              //       defaultValue: "Success",
                              //     })}
                              //     closable
                              //   >
                              //     {t("jobAppliedSuccessfully", {
                              //       defaultValue: "Job applied Successfully",
                              //     })}
                              //   </Notification>,
                              //   { placement: "topEnd" }
                              // );
                              ToasterNotification({
                                type: "success",
                                i18keyFormat: "jobAppliedSuccessfully",
                                message: "Job applied Successfully",
                                options: { position: "top-right", autoClose: 5000 },
                              });
                              let fullUrl;
                              if (
                                window.location.pathname.includes("/careers")
                              ) {
                                fullUrl =
                                  window.location.origin +
                                  "/careers/myaccount/guest";
                                window.open(fullUrl, "_blank");
                              } else {
                                // fullUrl = window.location.origin + "/myaccount/guest";
                                let rid = resp?.result?.resumeID;
                                let url = rid
                                  ? `/myaccount/guest?rid=${rid}`
                                  : `/myaccount/guest`;
                                fullUrl = window.location.origin + `${url}`;
                                window.open(fullUrl, "_blank");
                              }
                              // window.open(fullUrl, "_blank");

                              setOpen(false);
                            }
                          }
                        }
                      } else {
                        if (
                          resp?.result?.message.includes(
                            "Campaign is not active"
                          )
                        ) {
                          // toaster.push(
                          //   <Notification
                          //     type={"error"}
                          //     header={t("error", { defaultValue: "Error" })}
                          //     closable
                          //   >
                          //     {t("thisJobIsNoLongerAcceptingApplications", {
                          //       defaultValue:
                          //         "This job is no longer accepting applications",
                          //     })}
                          //   </Notification>,
                          //   { placement: "topEnd" }
                          // );
                          ToasterNotification({
                            type: "error",
                            i18keyFormat: "thisJobIsNoLongerAcceptingApplications",
                            message: "This job is no longer accepting applications",
                            options: { position: "top-right", autoClose: 5000 },
                          });
                          setOpen(false);
                        } else {
                          // toaster.push(
                          //   <Notification
                          //     type={"error"}
                          //     header={t("error", { defaultValue: "Error" })}
                          //     closable
                          //   >
                          //     {t("somethingWentWrongPleaseTryAgainLater", {
                          //       defaultValue:
                          //         "Something went wrong please try again later",
                          //     })}
                          //   </Notification>,
                          //   { placement: "topEnd" }
                          // );
                          ToasterNotification({
                            type: "error",
                            i18keyFormat: "somethingWentWrongPleaseTryAgainLater",
                            message: "Something went wrong please try again later",
                            options: { position: "top-right", autoClose: 5000 },
                          });
                        }
                      }
                    } else {
                      // toaster.push(
                      //   <Notification
                      //     type={"error"}
                      //     header={t("error", { defaultValue: "Error" })}
                      //     closable
                      //   >
                      //     {t("somethingWentWrongPleaseTryAgainLater", {
                      //       defaultValue:
                      //         "Something went wrong please try again later",
                      //     })}
                      //   </Notification>,
                      //   { placement: "topEnd" }
                      // );
                      ToasterNotification({
                        type: "error",
                        i18keyFormat: "somethingWentWrongPleaseTryAgainLater",
                        message: "YouSomething went wrong please try again later",
                        options: { position: "top-right", autoClose: 5000 },
                      });
                    }
                  })
                  .catch((error) => {
                    // toaster.push(
                    //   <Notification
                    //     type={"error"}
                    //     header={t("error", { defaultValue: "Error" })}
                    //     closable
                    //   >
                    //     {t("somethingWentWrongPleaseTryAgainLater", {
                    //       defaultValue:
                    //         "Something went wrong please try again later",
                    //     })}
                    //   </Notification>,
                    //   { placement: "topEnd" }
                    // );
                    ToasterNotification({
                      type: "error",
                      i18keyFormat: "somethingWentWrongPleaseTryAgainLater",
                      message: "Something went wrong please try again later",
                      options: { position: "top-right", autoClose: 5000 },
                    });
                    // console.log("error", error)
                  });
              }
            } else {
              setShowUploadedProfiles(false);
              setUploadedProfiles([]);
              // toaster.push(
              //   <Notification
              //     type={"error"}
              //     header={t("error", { defaultValue: "Error" })}
              //     closable
              //   >
              //     {t("pleaseUploadTheAcceptedFileFormats", {
              //       defaultValue: "Please upload the accepted file formats",
              //     })}
              //   </Notification>,
              //   { placement: "topEnd" }
              // );
              ToasterNotification({
                type: "error",
                i18keyFormat: "pleaseUploadTheAcceptedFileFormats",
                message: "Please upload the accepted file formats",
                options: { position: "top-right", autoClose: 5000 },
              });
            }
          } else {
            setShowUploadedProfiles(false);
            setUploadedProfiles([]);
            // toaster.push(
            //   <Notification
            //     type={"error"}
            //     header={t("error", { defaultValue: "Error" })}
            //     closable
            //   >
            //     {t("pleaseUploadAFileLessThanMb", {
            //       defaultValue: "Please upload a file less than 2Mb",
            //     })}
            //   </Notification>,
            //   { placement: "topEnd" }
            // );
            ToasterNotification({
              type: "error",
              i18keyFormat: "pleaseUploadAFileLessThanMb",
              message: "Please upload a file less than 2Mb",
              options: { position: "top-right", autoClose: 5000 },
            });
          }
        }
      } else {
        // toaster.push(
        //   <Notification
        //     type={"error"}
        //     header={t("error", { defaultValue: "Error" })}
        //     closable
        //   >
        //     {t("uploadingFilesLimitIs", {
        //       defaultValue: "Uploading files limit is 1",
        //     })}
        //   </Notification>,
        //   { placement: "topEnd" }
        // );
        ToasterNotification({
          type: "error",
          i18keyFormat: "uploadingFilesLimitIs",
          message: "Uploading files limit is 1",
          options: { position: "top-right", autoClose: 5000 },
        });
      }
    }
  };

  const {
    post: createResumes,
    data: createResumesData,
    isLoading: createResumesLoading,
    error: createResumesError,
  } = usePost("/user/createResumes");

  const {
    post: guestSignUp,
    data: guestSignUpData,
    isLoading: guestSignUpLoading,
    error: guestSignUpError,
  } = usePost("/user/guestsignup");

  useEffect(() => {
    if (notduplicate) {
      createProfileModalSubmit();
    }
  }, [notduplicate]);

  const createProfileModalSubmit = () => {
    let flag = true;
    if (getValues()) {
      // console.log("allvalues:", getValues())
      let createResumeObj = {
        phones: [],
        skills: [],
        from: page != "" ? page : "",
        campaignID:
          campaignID != undefined && campaignID != "" ? campaignID : "",
        jobSeekerID: user?._id != undefined && user?._id != "" ? user?._id : "",
        source:
          searchParams.get("source") != null ? searchParams.get("source") : "",
        referenceURL: isSsr
          ? ""
          : window.location.origin + window.location.pathname,
      };
      if (page == "userbasicprofile") {
        createResumeObj.companyID = user?.companyID;
      } else if (page == "referalresume") {
        createResumeObj.companyID = companyID;
      }
      // basic details
      createResumeObj.firstName =
        getValues()?.firstName !== undefined ? getValues()?.firstName : "";
      createResumeObj.middleName =
        getValues()?.middleName !== undefined ? getValues()?.middleName : "";
      createResumeObj.lastName =
        getValues()?.lastName !== undefined ? getValues()?.lastName : "";
      createResumeObj.locationText = getValues()?.profileAddressLocation ? getValues()?.profileAddressLocation : "";
      createResumeObj.city =
        getValues()?.profileCity !== undefined ? getValues()?.profileCity : "";
      createResumeObj.state =
        getValues()?.profileState !== undefined
          ? getValues()?.profileState
          : "";
      createResumeObj.country =
        getValues()?.profileCountry !== undefined
          ? getValues()?.profileCountry
          : "";
      createResumeObj.postalCode =
        getValues()?.profilePostalCode !== undefined
          ? getValues()?.profilePostalCode
          : "";
      createResumeObj.location =
        getValues()?.profileLocation !== undefined
          ? getValues()?.profileLocation
          : "";
      console.log(
        getValues()?.profilePostalCode,
        "getValues()?.profilePostalCodegetValues()?.profilePostalCode"
      );
      if (getValues()?.profilePostalCode == "") {
        flag = false;
        setError("profileAddressLocation", {
          type: "manaual",
          message: t("pleaseProvideatleastPostalCode", {
            defaultValue: "Please provide at least Postal Code",
          }),
        });
      }
      if (getValues()?.emails) {
        if (getValues()?.emails?.length > 0) {
          if (!checkEmailDuplicateOnSubmit(getValues()?.emails)) {
            flag = false;
          }
          createResumeObj.emails = getValues()?.emails;
        }
      }
      if (getValues()?.phones) {
        if (getValues()?.phones?.length > 0) {
          let phones = getValues()?.phones;
          if (!checkPhoneNumberDuplicateOnSubmit(phones)) {
            flag = false;
          }

          for (let i in phones) {
            if (
              phones[i]?.phone?.trim() != "" &&
              phones[i]?.phone !== undefined
            ) {
              let phoneSchema = {
                phone: "",
                country: "",
                countryCode: "",
                internationalPhoneCode: "",
                phoneNumberOnly: "",
              };
              let parsedNumber = parsePhoneNumber(String(phones[i]?.phone));
              phoneSchema.phone = parsedNumber?.number;
              phoneSchema.country = countryNames[parsedNumber?.country];
              phoneSchema.countryCode = parsedNumber?.country;
              phoneSchema.internationalPhoneCode =
                parsedNumber?.countryCallingCode;
              phoneSchema.phoneNumberOnly = parsedNumber?.nationalNumber;
              createResumeObj.phones.push(phoneSchema);
            }
          }
        }
      }

      // summary
      createResumeObj.objective =
        getValues()?.Objective !== undefined ? getValues()?.Objective : "";
      createResumeObj.summary =
        getValues()?.Summary !== undefined ? getValues()?.Summary : "";
      if (getValues()?.skills) {
        if (getValues()?.skills?.length > 0) {
          let skills = getValues()?.skills;
          for (let i in skills) {
            let skill = {};
            skill.skill = skills[i]?.skills;
            if (skills[i]?.yearsOfExperience == "") {
              skill.yearsOfExperience = 0;
            } else {
              skill.yearsOfExperience = parseInt(skills[i]?.yearsOfExperience);
            }
            createResumeObj.skills.push(skill);
          }
        }
      }

      createResumeObj.education =
        getValues()?.education !== undefined ? getValues()?.education : [];
      createResumeObj.experience =
        getValues()?.experience !== undefined ? getValues()?.experience : [];

      // other info
      if (
        getValues()?.minimumExpectedSalary !== undefined &&
        getValues()?.maximumExpectedSalary !== undefined
      ) {
        if (
          getValues()?.minimumExpectedSalary?.trim() != "" &&
          getValues()?.maximumExpectedSalary?.trim() != ""
        ) {
          if (
            parseInt(getValues()?.minimumExpectedSalary) >
            parseInt(getValues()?.maximumExpectedSalary)
          ) {
            flag = false;
            setError("minimumExpectedSalary", {
              type: "manual",
              message: (
                <Trans
                  i18nKey="minimumExpectedSalaryShouldBeLessThanMaximumExpectedSalary"
                  defaults="Minimum expected salary should be less than maximum expected salary"
                />
              ),
            });
          }
        }
      }

      createResumeObj.currentSalary =
        getValues()?.currentSalary !== undefined
          ? getValues()?.currentSalary
          : "";
      createResumeObj.salaryPeriod =
        getValues()?.salaryPeriod !== undefined
          ? getValues()?.salaryPeriod
          : "";
      createResumeObj.salaryCurrency =
        getValues()?.salaryCurrency !== undefined
          ? getValues()?.salaryCurrency
          : "";
      createResumeObj.noticePeriod =
        getValues()?.noticePeriod !== undefined
          ? getValues()?.noticePeriod
          : "";
      createResumeObj.workPermit =
        getValues()?.workPermit !== undefined ? getValues()?.workPermit : "";
      createResumeObj.gender =
        getValues()?.gender !== undefined ? getValues()?.gender : "";
      createResumeObj.veteranStatus =
        getValues()?.veteranStatus !== undefined
          ? getValues()?.veteranStatus
          : "";
      createResumeObj.dateOfBirth =
        getValues()?.dateOfBirth !== undefined ? getValues()?.dateOfBirth : "";
      createResumeObj.ageData =
        getValues()?.ageData !== undefined ? getValues()?.ageData : "";
      createResumeObj.maritalStatus =
        getValues()?.maritalStatus !== undefined
          ? getValues()?.maritalStatus
          : "";
      createResumeObj.nationality =
        getValues()?.nationality !== undefined ? getValues()?.nationality : "";
      createResumeObj.languagesKnown =
        getValues()?.languagesKnown !== undefined
          ? getValues()?.languagesKnown
          : [];
      createResumeObj.websites =
        getValues()?.websites !== undefined ? getValues()?.websites : [];
      createResumeObj.preferredLocations =
        getValues()?.preferred !== undefined ? getValues()?.preferred : [];
      createResumeObj.maximumExpectedSalary =
        getValues()?.maximumExpectedSalary !== undefined
          ? getValues()?.maximumExpectedSalary
          : "";
      createResumeObj.minimumExpectedSalary =
        getValues()?.minimumExpectedSalary !== undefined
          ? getValues()?.minimumExpectedSalary
          : "";
      createResumeObj.compensationCurrency =
        getValues()?.compensationCurrency !== undefined
          ? getValues()?.compensationCurrency
          : "";
      createResumeObj.compensationPeriod =
        getValues()?.compensationPeriod !== undefined
          ? getValues()?.compensationPeriod
          : "";
      createResumeObj.resumeID = resumeId;
      createResumeObj.fromUpload = fromUpload;
      if (notduplicate) {
        createResumeObj.notduplicate = false;
      } else {
        createResumeObj.notduplicate = true;
      }
      if (flag) {
        // console.log("createResumeObj", createResumeObj);

        if (page == "userbasicprofile" || page == "referalresume") {
          console.log(page, companyID);
          createUserResumes(createResumeObj)
            .then((resp) => {
              console.log(
                "response of create user from userbasic profile",
                resp
              );

              if (resp?.status) {
                if (resp?.result?.status && resp.result.status === true) {
                  if (
                    resp?.result?.disqualifiedExists &&
                    resp?.result?.disqualifiedExists === true
                  ) {
                    // toaster.push(
                    //   <Notification
                    //     type={"warning"}
                    //     header={<Trans i18nKey="warning" defaults="Warning" />}
                    //     closable
                    //   >
                    //     <Trans
                    //       i18nKey="youCanNotCreateAProfileWithTheseContactDetailsTheseContactDetailsAreAssociatedWithDisqualifiedProfile"
                    //       defaults="You can not create a profile with these contact details. These contact details are associated with disqualified profile"
                    //     />
                    //   </Notification>,
                    //   {
                    //     placement: "topEnd",
                    //   }
                    // );
                    ToasterNotification({
                      type: "warning",
                      i18keyFormat: "youCanNotCreateAProfileWithTheseContactDetailsTheseContactDetailsAreAssociatedWithDisqualifiedProfile",
                      message: "You can not create a profile with these contact details. These contact details are associated with disqualified profile",
                      options: { position: "top-right", autoClose: 5000 },
                    });
                    // setOpen(false);
                  } else {
                    if (resp?.result?.duplicate) {
                      if (
                        resp?.result?.resumes &&
                        resp?.result?.resumes?.length > 0
                      ) {
                        // setOpen(false);
                        setOpenDuplicate(true);
                        setDuplicateProfiles(resp?.result?.resumes);
                        // reset();
                        // setCreateManualProfile(false);
                      }
                      // toaster.push(
                      //   <Notification
                      //     type={"success"}
                      //     header={t("success", { defaultValue: "Success" })}
                      //     closable
                      //   >
                      //     {t("duplicateProfileFound", {
                      //       defaultValue: "Duplicate Profile Found",
                      //     })}
                      //   </Notification>,
                      //   { placement: "topEnd" }
                      // );
                      ToasterNotification({
                        type: "success",
                        i18keyFormat: "duplicateProfileFound",
                        message: "Duplicate Profile Found",
                        options: { position: "top-right", autoClose: 5000 },
                      });
                      // setOpen(false);
                      setOpenDuplicate(true);
                      setDuplicateProfiles(resp?.result?.resumes);
                    } else {
                      if (resp?.status && resp?.result?.resumeID != "") {
                        if (
                          resp?.result?.resumeID &&
                          resp.result.resumeID != ""
                        ) {
                          if (page == "userbasicprofile") {
                            setUser({
                              ...user,
                              resumeID: resp.result.resumeID,
                            });
                          }
                          setResumeID(resp?.result?.resumeID);
                        }
                        // toaster.push(
                        //   <Notification
                        //     type={"success"}
                        //     header={t("success", { defaultValue: "Success" })}
                        //     closable
                        //   >
                        //     {t("profileCreatedSuccessfully", {
                        //       defaultValue: "Profile Created Successfully",
                        //     })}
                        //   </Notification>,
                        //   { placement: "topEnd" }
                        // );
                        ToasterNotification({
                          type: "success",
                          i18keyFormat: "profileCreatedSuccessfully",
                          message: "Profile Created Successfully",
                          options: { position: "top-right", autoClose: 5000 },
                        });
                        setOpen(false);
                        setCreateManualProfile(false);
                        reset();
                      }
                    }
                  }
                } else {
                  // toaster.push(
                  //   <Notification
                  //     type={"error"}
                  //     header={t("error", { defaultValue: "Error" })}
                  //     closable
                  //   >
                  //     {t("somethingWentWrongPleaseTryAgainLater", {
                  //       defaultValue:
                  //         "Something went wrong please try again later",
                  //     })}
                  //   </Notification>,
                  //   { placement: "topEnd" }
                  // );
                  ToasterNotification({
                    type: "error",
                    i18keyFormat: "somethingWentWrongPleaseTryAgainLater",
                    message: "Something went wrong please try again later",
                    options: { position: "top-right", autoClose: 5000 },
                  });
                  setOpen(false);
                  setCreateManualProfile(false);
                }
              } else {
                // toaster.push(
                //   <Notification
                //     type={"error"}
                //     header={t("error", { defaultValue: "Error" })}
                //     closable
                //   >
                //     {t("somethingWentWrongPleaseTryAgainLater", {
                //       defaultValue:
                //         "Something went wrong please try again later",
                //     })}
                //   </Notification>,
                //   { placement: "topEnd" }
                // );
                ToasterNotification({
                  type: "error",
                  i18keyFormat: "somethingWentWrongPleaseTryAgainLater",
                  message: "Something went wrong please try again later",
                  options: { position: "top-right", autoClose: 5000 },
                });
              }
            })
            .catch((error) => {
              console.log(
                "error in create Resumes from userbasicprofile: ",
                error
              );
            });
        } else {
          createResumes(createResumeObj)
            .then((resp) => {
              // console.log("response", resp)

              if (resp?.status) {
                if (resp?.result?.status && resp.result.status === true) {
                  if (
                    resp?.result?.disqualifiedExists &&
                    resp?.result?.disqualifiedExists === true
                  ) {
                    // toaster.push(
                    //   <Notification
                    //     type={"warning"}
                    //     header={<Trans i18nKey="warning" defaults="Warning" />}
                    //     closable
                    //   >
                    //     <Trans
                    //       i18nKey="youCanNotCreateAProfileWithTheseContactDetailsTheseContactDetailsAreAssociatedWithDisqualifiedProfile"
                    //       defaults="You can not create a profile with these contact details. These contact details are associated with disqualified profile"
                    //     />
                    //   </Notification>,
                    //   {
                    //     placement: "topEnd",
                    //   }
                    // );
                    ToasterNotification({
                      type: "warning",
                      i18keyFormat: "youCanNotCreateAProfileWithTheseContactDetailsTheseContactDetailsAreAssociatedWithDisqualifiedProfile",
                      message: "You can not create a profile with these contact details. These contact details are associated with disqualified profile",
                      options: { position: "top-right", autoClose: 5000 },
                    });
                    // setOpen(false);
                  } else {
                    if (resp?.result?.duplicate) {
                      if (resp?.result?.attached) {
                        if (page && page == "guest") {
                          // setting resumeID in cookies for guest user
                          if (
                            resp?.result?.resumeID &&
                            resp.result.resumeID != ""
                          ) {
                            setCookies({
                              cookieName: "Guest_User_ResumeID",
                              cookieValue: resp?.result?.resumeID,
                              expires: DateTime.now()
                                .plus({ months: 3 })
                                .toISO(),
                            })
                              .then(async (res) => {
                                // console.log("cookie res", res);

                                if (res?.status) {
                                  setCookie(resp?.result?.resumeID);
                                  setGuestCookie(resp?.result?.resumeID);
                                }
                              })
                              .catch((error) => {
                                console.log("Error in setCookie : ", error);
                              });
                          }
                        }
                        let phoness = [];
                        if (getValues()?.phones) {
                          if (getValues()?.phones?.length > 0) {
                            let phones = getValues()?.phones;
                            if (!checkPhoneNumberDuplicateOnSubmit(phones)) {
                              flag = false;
                            }

                            for (let i in phones) {
                              if (
                                phones[i]?.phone?.trim() != "" &&
                                phones[i]?.phone !== undefined
                              ) {
                                let phone = {
                                  phone: "",
                                  country: "",
                                  countryCode: "",
                                  internationalPhoneCode: "",
                                  phoneNumberOnly: "",
                                };
                                let parsedNumber = parsePhoneNumber(
                                  String(phones[i]?.phone)
                                );
                                phone.phone = parsedNumber?.number;
                                phone.country =
                                  countryNames[parsedNumber?.country];
                                phone.countryCode = parsedNumber?.country;
                                phone.internationalPhoneCode =
                                  parsedNumber?.countryCallingCode;
                                phone.phoneNumberOnly =
                                  parsedNumber?.nationalNumber;
                                phoness.push(phone);
                              }
                            }
                          }
                        }
                        guestSignUp({
                          name:
                            getValues()?.firstName +
                            " " +
                            getValues()?.lastName,
                          email:
                            getValues()?.emails &&
                              getValues()?.emails?.length > 0
                              ? getValues()?.emails[0]
                              : "",
                          phone: phoness[0],
                          resumeID: resp?.result?.resumeID,
                        })
                          .then((res) => {
                            if (res?.status) {
                              console.log("guest signup successfull");
                            }
                          })
                          .catch((error) => {
                            console.log("Error in guest signup : ", error);
                          });

                        // toaster.push(
                        //   <Notification
                        //     type={"success"}
                        //     header={t("success", { defaultValue: "Success" })}
                        //     closable
                        //   >
                        //     {t("youHaveAlreadyAppliedForThisJob", {
                        //       defaultValue:
                        //         "You have already applied for this job",
                        //     })}
                        //   </Notification>,
                        //   { placement: "topEnd" }
                        // );
                        ToasterNotification({
                          type: "success",
                          i18keyFormat: "youHaveAlreadyAppliedForThisJob",
                          message: "You have already applied for this job",
                          options: { position: "top-right", autoClose: 5000 },
                        });
                        // const fullUrl =
                        //   window.location.origin + "/myaccount/guest";
                        // window.open(fullUrl, "_blank");
                        let fullUrl;
                        if (window.location.pathname.includes("/careers")) {
                          fullUrl =
                            window.location.origin + "/careers/myaccount/guest";
                        } else {
                          // fullUrl =
                          // window.location.origin + "/myaccount/guest";
                          // fullUrl = window.location.origin + "/myaccount/guest";
                          let rid = resp?.result?.resumeID;
                          let url = resp?.result?.resumeID
                            ? `/myaccount/guest?rid=${rid}`
                            : `/myaccount/guest`;
                          // fullUrl = window.location.origin + "/myaccount/guest";
                          fullUrl = window.location.origin + `${url}`;
                        }
                        // setTimeout(() => {
                        //   window.location.replace("/myaccount/guest");
                        // }, 1000);
                        setOpen(false);
                      } else {
                        if (
                          resp?.result?.resumes &&
                          resp?.result?.resumes?.length > 0
                        ) {
                          // setOpen(false);
                          setOpenDuplicate(true);
                          setDuplicateProfiles(resp?.result?.resumes);
                        }
                      }
                    } else {
                      if (page && page == "login") {
                        if (
                          resp?.result?.campaignID &&
                          resp.result.campaignID != "" &&
                          resp?.result?.resumeID &&
                          resp.result.resumeID != ""
                        ) {
                          if (
                            !user.attachedCampaigns.includes(
                              resp.result.campaignID
                            )
                          ) {
                            setUser({
                              ...user,
                              attachedCampaigns: [
                                ...user.attachedCampaigns,
                                resp?.result?.campaignID,
                              ],
                              resumeID: resp?.result?.resumeID,
                            });
                          } else {
                            setUser({
                              ...user,
                              resumeID: resp?.result?.resumeID,
                            });
                          }
                        }
                      } else {
                        if (page && page == "guest") {
                          // setting resumeID in cookies for guest user
                          if (
                            resp?.result?.resumeID &&
                            resp.result.resumeID != ""
                          ) {
                            setCookies({
                              cookieName: "Guest_User_ResumeID",
                              cookieValue: resp?.result?.resumeID,
                              expires: DateTime.now()
                                .plus({ months: 3 })
                                .toISO(),
                            })
                              .then((res) => {
                                // console.log("cookie res", res);

                                if (res?.status) {
                                  setCookie(resp?.result?.resumeID);
                                  setGuestCookie(resp?.result?.resumeID);
                                }
                              })
                              .catch((error) => {
                                console.log("Error in setCookie : ", error);
                              });
                            let phoness = [];
                            if (getValues()?.phones) {
                              if (getValues()?.phones?.length > 0) {
                                let phones = getValues()?.phones;
                                if (
                                  !checkPhoneNumberDuplicateOnSubmit(phones)
                                ) {
                                  flag = false;
                                }

                                for (let i in phones) {
                                  if (
                                    phones[i]?.phone?.trim() != "" &&
                                    phones[i]?.phone !== undefined
                                  ) {
                                    let phone = {
                                      phone: "",
                                      country: "",
                                      countryCode: "",
                                      internationalPhoneCode: "",
                                      phoneNumberOnly: "",
                                    };
                                    let parsedNumber = parsePhoneNumber(
                                      String(phones[i]?.phone)
                                    );
                                    phone.phone = parsedNumber?.number;
                                    phone.country =
                                      countryNames[parsedNumber?.country];
                                    phone.countryCode = parsedNumber?.country;
                                    phone.internationalPhoneCode =
                                      parsedNumber?.countryCallingCode;
                                    phone.phoneNumberOnly =
                                      parsedNumber?.nationalNumber;
                                    phoness.push(phone);
                                  }
                                }
                              }
                            }
                            guestSignUp({
                              name:
                                getValues()?.firstName +
                                " " +
                                getValues()?.lastName,
                              email:
                                getValues()?.emails &&
                                  getValues()?.emails?.length > 0
                                  ? getValues()?.emails[0]
                                  : "",
                              phone: phoness[0],
                              resumeID: resp?.result?.resumeID,
                            })
                              .then((res) => {
                                if (res?.status) {
                                  console.log("guest signup successfull");
                                }
                              })
                              .catch((error) => {
                                console.log("Error in guest signup : ", error);
                              });
                          }
                          let fullUrl;
                          if (window.location.pathname.includes("/careers")) {
                            fullUrl =
                              window.location.origin +
                              "/careers/myaccount/guest";
                            window.open(fullUrl, "_blank");
                          } else {
                            // fullUrl = window.location.origin + "/myaccount/guest";
                            let rid = resp?.result?.resumeID;
                            let url = rid
                              ? `/myaccount/guest?rid=${rid}`
                              : `/myaccount/guest`;
                            fullUrl = window.location.origin + `${url}`;
                            window.open(fullUrl, "_blank");
                          }
                        }
                      }
                      // toaster.push(
                      //   <Notification
                      //     type={"success"}
                      //     header={t("success", { defaultValue: "Success" })}
                      //     closable
                      //   >
                      //     {t("jobAppliedSuccessfully", {
                      //       defaultValue: "Job applied Successfully",
                      //     })}
                      //   </Notification>,
                      //   { placement: "topEnd" }
                      // );
                      ToasterNotification({
                        type: "success",
                        i18keyFormat: "jobAppliedSuccessfully",
                        message: "Job applied Successfully",
                        options: { position: "top-right", autoClose: 5000 },
                      });
                      // window.open(fullUrl, "_blank");
                      setOpen(false);
                    }
                  }
                } else {
                  if (
                    resp?.result?.message.includes("Campaign is not active")
                  ) {
                    // toaster.push(
                    //   <Notification
                    //     type={"error"}
                    //     header={t("error", { defaultValue: "Error" })}
                    //     closable
                    //   >
                    //     {t("thisJobIsNoLongerAcceptingApplications", {
                    //       defaultValue:
                    //         "This job is no longer accepting applications",
                    //     })}
                    //   </Notification>,
                    //   { placement: "topEnd" }
                    // );
                    ToasterNotification({
                      type: "error",
                      i18keyFormat: "thisJobIsNoLongerAcceptingApplications",
                      message: "This job is no longer accepting applications",
                      options: { position: "top-right", autoClose: 5000 },
                    });
                    setOpen(false);
                  } else {
                    // toaster.push(
                    //   <Notification
                    //     type={"error"}
                    //     header={t("error", { defaultValue: "Error" })}
                    //     closable
                    //   >
                    //     {t("somethingWentWrongPleaseTryAgainLater", {
                    //       defaultValue:
                    //         "Something went wrong please try again later",
                    //     })}
                    //   </Notification>,
                    //   { placement: "topEnd" }
                    // );
                    ToasterNotification({
                      type: "error",
                      i18keyFormat: "somethingWentWrongPleaseTryAgainLater",
                      message: "Something went wrong please try again later",
                      options: { position: "top-right", autoClose: 5000 },
                    });
                  }
                }
              } else {
                // toaster.push(
                //   <Notification
                //     type={"error"}
                //     header={t("error", { defaultValue: "Error" })}
                //     closable
                //   >
                //     {t("somethingWentWrongPleaseTryAgainLater", {
                //       defaultValue:
                //         "Something went wrong please try again later",
                //     })}
                //   </Notification>,
                //   { placement: "topEnd" }
                // );
                ToasterNotification({
                  type: "error",
                  i18keyFormat: "somethingWentWrongPleaseTryAgainLater",
                  message: "Something went wrong please try again later",
                  options: { position: "top-right", autoClose: 5000 },
                });
              }
            })
            .catch((error) => {
              console.log("error in createResumes : ", error);
              // toaster.push(
              //   <Notification
              //     type={"error"}
              //     header={t("error", { defaultValue: "Error" })}
              //     closable
              //   >
              //     {t("somethingWentWrongPleaseTryAgainLater", {
              //       defaultValue: "Something went wrong please try again later",
              //     })}
              //   </Notification>,
              //   { placement: "topEnd" }
              // );
              ToasterNotification({
                type: "error",
                i18keyFormat: "somethingWentWrongPleaseTryAgainLater",
                message: "Something went wrong please try again later",
                options: { position: "top-right", autoClose: 5000 },
              });
            });
        }
      }
    }
  };

  function checkEmailDuplicateOnSubmit(emails) {
    let emailAvailable = true;
    for (let i = 0; i < emails.length; i++) {
      for (let j = 0; j < emails.length; j++) {
        if (i != j) {
          if (emails[i]?.email == emails[j]?.email) {
            setError("emails[" + j + "].email", {
              type: "manual",
              message: t("emailAlreadyExists", {
                defaultValue: "Email already exists",
              }),
            });
            emailAvailable = false;
          }
        }
      }
    }
    return emailAvailable;
  }

  function checkPhoneNumberDuplicateOnSubmit(phones) {
    let phoneNumberAvailable = true;
    for (let i = 0; i < phones.length; i++) {
      for (let j = 0; j < phones.length; j++) {
        if (i != j) {
          if (phones[i]?.phone == phones[j]?.phone) {
            setError("phones[" + j + "].phone", {
              type: "manual",
              message: t("phonenumberIsAlreadyPresent", {
                defaultValue: "Phonenumber is already present",
              }),
            });
            phoneNumberAvailable = false;
          }
        }
      }
    }
    return phoneNumberAvailable;
  }

  useEffect(() => {
    if (open === false) {
      setFromUpload(false);
    }
  }, [open]);
  return (
    <Modal
      open={open}
      onClose={() => setOpen(false)}
      overflow={false}
      // enforceFocus={true}
      size={!showUploadedProfiles ? "lg" : "calc(100% - 120px)"}
    >
      <Modal.Header>
        <Modal.Title>
          {!createManualProfile && (page != "userbasicprofile" && page != "referalresume") ? (
            <>
              <h5 className="fw-bold">
                <Trans i18nKey="applyFor" defaults="Apply For " />
                {campaignName}
              </h5>
              {!showUploadedProfiles && (
                <div className="text-muted fs-6">
                  <Trans
                    i18nKey="getStartedByUploadingYourResume"
                    defaults="Get started by uploading your resume"
                  />
                </div>
              )}
              <hr />
            </>
          ) : (
            <>
              <h4>
                <Trans i18nKey="createProfile" defaults="Create Profile" />
              </h4>
            </>
          )}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {showUploadedProfiles ? (
          <Suspense fallback={<Loading rows={1} />}>
            <UploadedProfilesDetails
              uploadedProfiles={uploadedProfiles}
              register={register}
              getValues={getValues}
              setValue={setValue}
            ></UploadedProfilesDetails>
          </Suspense>
        ) : (
          <>
            {/* {previewGuestResume ? (
              <Suspense fallback={<Loading rows={1} />}>
                <GuestResumePreview
              step={step}
              setStep={setStep}
              setOpen={setOpen}
              resumeId={resumeId}
              campaignID={campaignID}
              resumeEdit={resumeEdit}
            ></GuestResumePreview>
              </Suspense>
            ) : ( */}
            <>
              <div className="row my-3 mx-2">
                <div className="col-md-6 col-lg-6 col-sm-12 col-xs-12  d-flex flex-column align-items-center justify-content-center">
                  <Suspense fallback={<Loading rows={1} />}>
                    <UploadProfileNewLayout
                      fileOnChange={fileOnChange}
                      register={register}
                      control={control}
                    ></UploadProfileNewLayout>
                  </Suspense>
                  <div className="text-muted">
                    <span>
                      <Trans defaults="OR" i18nKey="OR" />
                    </span>
                  </div>
                  <div
                    className="my-3"
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      setShowUploadedProfiles(true);
                      setCreateManualProfile(true);
                      setResumeId("");
                      // setCreateButtonName(
                      //     <Trans i18nKey="create" defaults="Create" />
                      // );
                    }}
                  >
                    <Suspense fallback={<Loading rows={1} />}>
                      <CreateProfileForm></CreateProfileForm>
                    </Suspense>
                  </div>
                  {/* <div className='d-flex justify-content-center text-center my-2 text-secondary'>
                                    <Trans defaults='We accept only doc, docx, pdf and txt with a max file size up to: 2 MB' i18nKey="formatSizeWarningMessage" />
                                </div> */}
                </div>
                <div
                  className="col-md-6 col-lg-6 col-sm-12 col-xs-12 text-dark mb-4 bg-muted p-3 rounded"
                  style={{ backgroundColor: "#F1F3E0" }}
                >
                  <div className="fw-bold">
                    <h6 className="fw-bold">
                      <Trans
                        defaults="Why Create a Profile?"
                        i18nKey="whyCreateAProfile"
                      />
                    </h6>
                  </div>
                  <div className="ms-5 mt-4">
                    <h6 className="fw-bold">
                      <>
                        <FontAwesomeIcon
                          icon={faSuitcase}
                          className="userIcon me-2"
                        />
                        <Trans
                          defaults="Get Smart Job Matches"
                          i18nKey="getSmartJobMatches"
                        />
                      </>
                    </h6>
                    <div className="text-muted fs-6">
                      <Trans
                        defaults="We'll use your skills to suggest jobs you're a great fit for."
                        i18nKey="WellUseYourSkillstoSuggestJobsYoureaGreatFitFor"
                      />
                    </div>
                  </div>
                  <div className="ms-5 mt-4">
                    <h6 className="fw-bold">
                      <>
                        <FontAwesomeIcon
                          icon={faForward}
                          className="userIcon me-2"
                        />
                        <Trans
                          defaults="Apply Faster Next Time"
                          i18nKey="applyFasterNextTime"
                        />
                      </>
                    </h6>
                    <div className="text-muted fs-6">
                      <Trans
                        defaults="Your info will be saved for one-click applications."
                        i18nKey="yourInfoWillbeSavedForOneClickApplications"
                      />
                    </div>
                  </div>
                  <div className="ms-5 mt-4">
                    <h6 className="fw-bold">
                      <>
                        <FontAwesomeIcon
                          icon={faMagnifyingGlass}
                          className="userIcon me-2"
                        />
                        <Trans
                          defaults="Get Noticed by Recruiters"
                          i18nKey="getNoticedByRecruiters"
                        />
                      </>
                    </h6>
                    <div className="text-muted fs-6">
                      <Trans
                        defaults="A complete profile stands out and helps us find you for unlisted roles."
                        i18nKey="aCompleteProfileStandsAutAndHelpsusFindYouForUnlistedRoles"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </>
            {/* )} */}
          </>
        )}
        {/* 
        {previewGuestProfile && (
          <Suspense fallback={<Loading rows={1} />}>
            <GuestProfilePreview
              register={register}
              control={control}
              setValue={setValue}
              handleSubmit={handleSubmit}
              getValues={getValues}
              errors={errors}
              watch={watch}
              clearErrors={clearErrors}
              required={false}
              setError={setError}
            ></GuestProfilePreview>
          </Suspense>
        )} */}

        {createManualProfile && (
          <Suspense fallback={<Loading rows={1} />}>
            <CreateManualProfileMain
              register={register}
              control={control}
              step={step}
              setStep={setStep}
              setValue={setValue}
              handleSubmit={handleSubmit}
              getValues={getValues}
              errors={errors}
              page={page}
              watch={watch}
              clearErrors={clearErrors}
              required={false}
              setError={setError}
              resumeId={resumeId}
              campaignID={campaignID}
              companyID={companyID}
            ></CreateManualProfileMain>
          </Suspense>
        )}
        {!showUploadedProfiles && !user?._id && (
          <>
            <hr />
            <div className="d-flex justify-content-center text-muted fs-6">
              <Trans
                i18nKey="alreadyHaveAnAccount"
                defaults="Already have an account"
              />
              {"?"}
              <span className="ms-1"></span>
              <div
                className="text-primary clickCss"
                onClick={() => {
                  handleLogin();
                }}
              >
                <b>
                  <Trans i18nKey="login" defaults="Login" />
                </b>
              </div>
            </div>
          </>
        )}
      </Modal.Body>
      <Modal.Footer>
        {showUploadedProfiles && (
          <>
            <Button
              className="btn-sm float-start"
              variant="secondary"
              onClick={() => {
                setShowUploadedProfiles(false);
                setCreateManualProfile(false);
                setUploadedProfiles([]);
                setStep(0);
              }}
            >
              <Trans i18nKey="goBack" defaults="Go Back" />
            </Button>
            {createManualProfile ? (
              <Button
                variant="primary"
                className="btn-sm"
                onClick={handleSubmit(createProfileModalSubmit)}
                disabled={
                  !watch()?.createAge ||
                  !watch()?.createLegal ||
                  !watch()?.createConsent ||
                  createResumesLoading ||
                  createUserResumesLoading ||
                  updateReferraldataLoading
                }
              >
                {(createResumesLoading ||
                  createUserResumesLoading ||
                  updateReferraldataLoading) && (
                    <Spinner animation="border" size="sm" className="me-1" />
                  )}
                <Trans i18nKey="submit" defaults="Submit" />
              </Button>
            ) : (
              <Button
                variant="primary"
                className="btn-sm"
                onClick={handleSubmit(uploadProfiles)}
                disabled={
                  !watch()?.uploadAge ||
                  !watch()?.uploadLegal ||
                  !watch()?.uploadConsent||
                  uploadResumesLoading ||
                  uploadUserResumesLoading
                }
              >
                {(uploadResumesLoading || uploadUserResumesLoading) && (
                  <Spinner animation="border" size="sm" className="me-1" />
                )}
                <Trans i18nKey="upload" defaults="Upload" />
              </Button>
            )}
          </>
        )}
      </Modal.Footer>
    </Modal>
  );
};

export default ApplyNowNewLayout;
